import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WslAccountLookupComponent } from './wsl-account-lookup.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [WslAccountLookupComponent],
  exports: [WslAccountLookupComponent]
})
export class WslAccountLookupModule { }
